export default {
      id: "image-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#image",
      toString: function () {
        return this.url;
      }
    }